"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSpacingConfig = void 0;
var responsive_1 = require("./responsive");
var assert_1 = require("tsafe/assert");
var defaultSpacingConfig = function (_a) {
    var factor = _a.factor, windowInnerWidth = _a.windowInnerWidth, rootFontSizePx = _a.rootFontSizePx;
    return rootFontSizePx *
        (function callee(factor) {
            assert_1.assert(factor >= 0, "factor must be positive");
            if (!Number.isInteger(factor)) {
                return ((callee(Math.floor(factor)) + callee(Math.floor(factor) + 1)) /
                    2);
            }
            if (factor === 0) {
                return 0;
            }
            if (factor > 6) {
                return (factor - 5) * callee(6);
            }
            if (windowInnerWidth >= responsive_1.breakpointsValues.xl) {
                switch (factor) {
                    case 1:
                        return 0.25;
                    case 2:
                        return 0.5;
                    case 3:
                        return 1;
                    case 4:
                        return 1.5;
                    case 5:
                        return 2;
                    case 6:
                        return 2.5;
                }
            }
            if (windowInnerWidth >= responsive_1.breakpointsValues.lg) {
                switch (factor) {
                    case 1:
                        return 0.25;
                    case 2:
                        return 0.5;
                    case 3:
                        return 1;
                    case 4:
                        return 1;
                    case 5:
                        return 1.5;
                    case 6:
                        return 2;
                }
            }
            switch (factor) {
                case 1:
                    return 0.25;
                case 2:
                    return 0.25;
                case 3:
                    return 0.5;
                case 4:
                    return 1;
                case 5:
                    return 1;
                case 6:
                    return 1.5;
            }
            assert_1.assert(false);
        })(factor);
};
exports.defaultSpacingConfig = defaultSpacingConfig;
//# sourceMappingURL=spacing.js.map